export default __webpack_public_path__ + "static/media/Transportation_04.80afb357.png";